module.exports = __webpack_public_path__ + "img/jp-home-head-dark.7a62145b.png";